/*
 ** vue router: HAF
 */
import type { RouteRecordRaw } from 'vue-router';

const vrtHAF: RouteRecordRaw = {
  path: '/eservices/haf',
  name: 'vrtHAF',
  component: () => import('src/layouts/vcleSystem.vue'),
  children: [
    {
      path: 'dips/demeritpoints/report',
      name: 'vrtHAFDIPSDemeritPointsReport',
      component: () => import('./vpgHAFDIPSDemeritPointsReport.vue'),
    },
  ],
};

export default vrtHAF;
